import { render } from "./RewardPatterns.vue?vue&type=template&id=61246930&scoped=true"
import script from "./RewardPatterns.vue?vue&type=script&lang=js"
export * from "./RewardPatterns.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-61246930"

export default script